import React from "react";
import { StyleSheet, Text } from "react-native";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  main: {
    ...theme.title.defaults,
    ...theme.title["l6-bold"],
  },
});

interface Props {
  style: {};
  children: JSX.Element;
  numberOfLines?: number | undefined;
}

const Title = ({ style, children, numberOfLines = undefined }: Props) => {
  return (
    <Text numberOfLines={numberOfLines} style={[styles.main, style]}>
      {children}
    </Text>
  );
};

export { Title };
